export class AppUser {
  constructor(
    public uid: string,
    public name: string,
    public email: string
  ) {
  }
}
